import reduce from 'image-blob-reduce';
export class PicturesService {
    constructor(uuidGenerator, serviceUrl) {
        this.uuidGenerator = uuidGenerator;
        this.serviceUrl = serviceUrl;
        this.picturesEndpoint = new URL('picture', this.serviceUrl).href;
    }
    async uploadPicture(file) {
        const reducer = reduce();
        const blob = await reducer.toBlob(file, {
            max: 500,
        });
        const pictureId = this.uuidGenerator.createUuid();
        const formData = new FormData();
        formData.set('pictureId', pictureId);
        formData.set('file', blob);
        formData.set('type', file.type);
        const response = await fetch(this.picturesEndpoint, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al enviar la imagen.');
        }
        return pictureId;
    }
    async deletePicture(pictureId) {
        const response = await fetch(`${this.picturesEndpoint}/${pictureId}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar la imagen.');
        }
    }
}
